import { Route, Routes } from "react-router-dom";

import Create from "./Create/Create";

const Batch = () => {
  return (
    <Routes>
      <Route path="nueva/*" element={<Create />} />
    </Routes>
  );
};

export default Batch;
